import React from 'react';

import { RangeProps } from 'rc-slider';

import { StyledRange } from './styles';

const Slider = (props: RangeProps) => <StyledRange {...props} />;

export default Slider;
